import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import {  DOCTOR_API } from '../../ApiNames';


export const fetchData1 = (cases: any) => ({
    type: 'FETCH_DATA1_SUCCESS',
    payload: cases,
});
export const fetchData2 = (chat: any) => ({
    type: 'FETCH_DATA2_SUCCESS',
    payload: chat,
});
export const fetchData3 = (docdata: any) => ({
    type: 'FETCH_DATA3_SUCCESS',
    payload: docdata,
});
export const view = (viewdoc: any) => ({
    type: 'FETCH_VIEW_SUCCESS',
    payload: viewdoc,
});
export const upload = (docupload: any) => ({
    type: 'FETCH_DOC_SUCCESS',
    payload: docupload,
});
export const patient = (patient: any) => ({
    type: 'FETCH_PAT_SUCCESS',
    payload: patient,
});


export const fetchPatientDetails = (uid:any,id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:1,uid:uid,need:id};
            const apiname = DOCTOR_API.doctorcasedetails_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData1(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchChatDatasss = (uid:any,id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:3,uid:uid,need:id};
            const apiname = DOCTOR_API.doctorcasedetails_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData2(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchDocumentsData = (uid:any,id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:4,uid:uid,need:id};
            const apiname = DOCTOR_API.doctorcasedetails_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchData3(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const ViewDocument = (docid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:7,docid:docid};
            const apiname = DOCTOR_API.doctorcasedetails_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(view(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const UploadImageData = (fileToUpload:any,uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            // const payload = {document:fileToUpload,uid:uid};
            const apiname = DOCTOR_API.casedocumentsuploads_API;
            //create form data and append the file
            const formData = new FormData();
            const filename = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload',fileToUpload,filename);
            const response = await LoginService.uploadimage(apiname,formData);
            dispatch(upload(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const GetPat = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:4,need:id};
            const apiname = DOCTOR_API.patientdata_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(patient(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

